import { inject, Injectable } from '@angular/core';
import { ApiRequestService, Material, SelectOption } from '@prekog/common-ui';
import { map, Observable, shareReplay } from 'rxjs';
import { GetProductsResponse } from '../products/product-list/get-products.response';
import { Festival } from './festival';
import { GetFestivalsResponse } from './getfestivalsresponse';
import { GetPartnersResponse } from './getpartnersresponse';
import { Partner } from './partner';

@Injectable({ providedIn: 'root' })
export class ReferenceDataService {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
    private _products$?: Observable<Material[]>;
    private _partners$?: Observable<Partner[]>;
    private _festivals$?: Observable<Festival[]>;

    loadProducts(): Observable<Material[]> {
        if (!this._products$) {
            this._products$ = this._apiRequestService.sendRequest(this._storeBaseUrl, {}, true, '/admin/getProducts').pipe(
                map((response) => (response as GetProductsResponse).productList ?? []),
                shareReplay(1)
            );
        }
        return this._products$;
    }

    loadPartners(): Observable<Partner[]> {
        if (!this._partners$) {
            this._partners$ = this._apiRequestService.sendRequest(this._storeBaseUrl, {}, true, '/admin/getPartners').pipe(
                map((response) => (response as GetPartnersResponse).partnerList ?? []),
                shareReplay(1)
            );
        }
        return this._partners$;
    }

    loadFestivals(): Observable<Festival[]> {
        if (!this._festivals$) {
            this._festivals$ = this._apiRequestService.sendRequest(this._storeBaseUrl, {}, true, '/admin/getFestivals').pipe(
                map((response) => (response as GetFestivalsResponse).festivalList ?? []),
                shareReplay(1)
            );
        }
        return this._festivals$;
    }

    getProductOptions(): Observable<SelectOption[]> {
        return this.loadProducts().pipe(
            map((products) => products.map((p) => ({ id: p.id!, name: `${p.title} - ${p.author} [${p.isbn}]` })))
        );
    }

    getPartnerOptions(): Observable<SelectOption[]> {
        return this.loadPartners().pipe(map((partners) => partners.map((p) => ({ id: p.id!, name: p.name! }))));
    }

    getFestivalOptions(): Observable<SelectOption[]> {
        return this.loadFestivals().pipe(map((festivals) => festivals.map((f) => ({ id: f.id!, name: f.name! }))));
    }

    invalidateCache(): void {
        this._products$ = undefined;
        this._partners$ = undefined;
        this._festivals$ = undefined;
    }
}
